import { createFlagsHook } from '@omnea-app/fe-org-settings/createFlagsHook'

export const useSavingsDashboardLdFlags = createFlagsHook<typeof import('./flags.json')>()
